import { Intersection, Object3D, XRGripSpace, XRTargetRaySpace } from 'three';
import { create } from 'zustand';
import { redux } from 'zustand/middleware';
// import { devtools } from 'zustand/middleware';

// type IInteraction = any;

export interface XRInteractionEvent {
    intersection?: Intersection;
    intersections: Intersection[];
}

export type IXRInteractionHandler = (event: XRInteractionEvent) => void

type IInteractionObject = Record<IXRInteractionType, React.RefObject<IXRInteractionHandler>>

export type IXRInteractionType = 'onSelect' | 'onSelectStart' | 'onSelectEnd';

export enum IWebXRActionType {
	ADD_INTERACTION = 'ADD_INTERACTION'
}

interface IAddWebXRActionPayload {
    target: Object3D, 
    eventType: IXRInteractionType, 
    handlerRef: React.RefObject<IXRInteractionHandler>
}

interface IAddWebXRAction {
	type: IWebXRActionType.ADD_INTERACTION;
	payload: IAddWebXRActionPayload;
}

type IActionObjUnion = IAddWebXRAction;

export type IWebXRState = {
	interactions: Map<Object3D, IInteractionObject>;
	dispatch?: (args: IActionObjUnion) => IActionObjUnion;
};

const initialState: IWebXRState = {
	interactions: new Map<Object3D, IInteractionObject>()
};

function reducer(state: IWebXRState, action: IActionObjUnion): IWebXRState {
	switch (action.type) {
		case IWebXRActionType.ADD_INTERACTION: {
			const { payload } = action;
			let interactionObject = state.interactions.get(payload.target);

			if (interactionObject) {
				interactionObject[payload.eventType] = payload.handlerRef;
			} else {
				interactionObject = {[payload.eventType]: payload.handlerRef} as IInteractionObject;
			}

            state.interactions.set(payload.target, interactionObject);
			return state;
		}
		default: 
			return state
	}
}

export const useWebXRStore = create(redux(reducer, initialState));
// export const useDataStore = create(devtools(redux(reducer, initialState)));

